import { lazy } from 'react';

const LiveCasinoCarousel = lazy(
	() =>
		import(
			/* webpackChunkName: "live-casino-carousel" */
			'./live-casino-carousel.js'
		)
);

export default LiveCasinoCarousel;
